/**
 * File: src/components/about.js
 * Mô tả: Component giới thiệu studio SNT Games, thông tin công ty và founder, hỗ trợ i18n phòng chống lỗi undefined.
 * Liên quan: src/i18n/i18n-service.js, src/data/site-config.js
 */

import { createElement } from '../utils/dom.js';
import { siteConfig } from '../data/site-config.js';
import { t, onLanguageChange } from '../i18n/i18n-service.js';

export const renderAbout = () => {
  const section = createElement('section', {
    className: 'section about-section',
    attributes: { id: 'about' },
  });

  const renderContent = () => {

    section.innerHTML = `
      <div class="container">
        <div class="about-grid">
          <div>
            <span class="section-badge">${t('about.badge')}</span>
            <h2 class="section-title">${t('about.title')}</h2>
            <p class="about-description">${t('about.story')}</p>
            <p class="company-facts">${siteConfig.contact.location} · ${t('about.founded')} ${siteConfig.founded}</p>
          </div>
          <article class="founder-card" aria-labelledby="founder-heading">
            <span class="section-badge">${t('about.founder')}</span>
            <h3 id="founder-heading">${siteConfig.founder.name}</h3>
            <p class="founder-role">${siteConfig.founder.role}</p>
            <p class="about-description">${t('about.founderBio')}</p>
            <a class="company-email" href="mailto:${siteConfig.contact.email}">${siteConfig.contact.email}</a>
          </article>
        </div>
      </div>
    `;
  };

  renderContent();
  onLanguageChange(() => renderContent());

  return section;
};
